var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 131,
  height: 131,
  viewBox: "0 0 131 131",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 34.4113,
  y: 44.9689,
  width: 8,
  height: 28,
  rx: 4,
  transform: "rotate(120 34.4113 44.9689)",
  fill: "#DEDAFE"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 41.7581,
  y: 94.2439,
  width: 8,
  height: 28,
  rx: 4,
  transform: "rotate(30 41.7581 94.2439)",
  fill: "#F6F5FF"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 30.0978,
  y: 80.5836,
  width: 8,
  height: 28,
  rx: 4,
  transform: "rotate(60 30.0978 80.5836)",
  fill: "#F6F5FF"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 28,
  rx: 4,
  transform: "matrix(1 8.85319e-08 8.85319e-08 -1 58.9722 28)",
  fill: "#DEDAFE"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 28,
  rx: 4,
  transform: "matrix(0.863577 -0.504217 -0.504217 -0.863577 41.7581 36.3116)",
  fill: "#DEDAFE"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 28.0387,
  y: 62.0743,
  width: 8,
  height: 28,
  rx: 4,
  transform: "rotate(90.2794 28.0387 62.0743)",
  fill: "#DEDAFE"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 122.746,
  y: 95.9689,
  width: 8,
  height: 28,
  rx: 4,
  transform: "rotate(120 122.746 95.9689)",
  fill: "#FBFBFF"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 92.7581,
  y: 5.90932,
  width: 8,
  height: 28,
  rx: 4,
  transform: "rotate(30 92.7581 5.90932)",
  fill: "#6D54FF"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 119.265,
  y: 28.1414,
  width: 8,
  height: 28,
  rx: 4,
  transform: "rotate(60 119.265 28.1414)",
  fill: "#6D54FF"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 28,
  rx: 4,
  transform: "matrix(1 8.85319e-08 8.85319e-08 -1 58.9722 131)",
  fill: "#F6F5FF"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 130.249,
  y: 61.041,
  width: 8,
  height: 28,
  rx: 4,
  transform: "rotate(90.2794 130.249 61.041)",
  fill: "#4F31FF"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 28,
  rx: 4,
  transform: "matrix(0.863577 -0.504217 -0.504217 -0.863577 93.3343 124.979)",
  fill: "#F6F5FF"
})));
export default SvgLoading;